import { Components, Theme } from "@mui/material/styles";

export const MuiTable: Components<Theme>["MuiTable"] = {
    defaultProps: {},
    styleOverrides: {
        root: {
            borderCollapse: "separate",
        },
    },
};

export const MuiTableCell: Components<Theme>["MuiTableCell"] = {
    defaultProps: {},
    styleOverrides: {
        root: {
            borderBottomColor: "var(--mui-palette-gray-100)",
            backgroundColor: "white",
            padding: 0,
            variants: [
                {
                    props: { variant: "head" },
                    style: {
                        borderBottomWidth: "2px",
                        fontSize: "sm",
                        fontWeight: 700,
                    },
                },
            ],
        },
    },
};

export const MuiTableRow: Components<Theme>["MuiTableRow"] = {
    defaultProps: {
        hover: true,
    },
    styleOverrides: {
        root: {
            "&.MuiTableRow-hover.MuiTableRow-head:hover": {
                backgroundColor: "initial",
            },

            "&.MuiTableRow-hover:not(.MuiTableRow-head):hover .MuiTableCell-root": {
                backgroundColor: "var(--mui-palette-gray-50)",
            },
        },
    },
};
